import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import EmailForm from './EmailForm';

class TourManagerModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount(){
    this.props.requestTourManagers();
  }
  handleSubmit(values) {
    let managersList = this.props.tourManagers;
    let isTourManagerExist = managersList.filter(itm => itm.email == values.email).length;
    if(isTourManagerExist){
      alert("Please use email id other than current travel agent(s).");
    }else{
      this.props.sendToTourManager(this.props.tour.id, values);
      this.props.onClose();
    }
  }
  handleCancel(event) {
    event.preventDefault();
    this.props.onClose();
  }
  renderForm() {
    return (
      <Modal show={this.props.show} onHide={this.props.onClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Share</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Invite Clients to collaborate with you on this travel plan. Clients will have read-only access to view hotels, routes, and participants.
          </p>
          <EmailForm onSubmit={this.handleSubmit} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
  render() {
    return this.renderForm();
  }
}

TourManagerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  sendToTourManager: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default TourManagerModal;



// WEBPACK FOOTER //
// src/routes/tours/components/TourManagerModal.js